import type { Room } from '../types/rooms';
import type { OutTypes } from './schedules';


export default function (
  rooms:          Room[] | undefined,
  importErrors:   string[],
  importWarnings: string[],
): OutTypes.location[] {
  return rooms?.map(room => { return {
    ids:         room.id.toString(),
    displayName: room.name
  };}) ?? [];
}
